import { render } from "./HrPerWeekChart.vue?vue&type=template&id=074b58dc"
import script from "./HrPerWeekChart.vue?vue&type=script&lang=js"
export * from "./HrPerWeekChart.vue?vue&type=script&lang=js"
script.render = render

export default script